// src/services/api/LinkedinApiService.ts
import axios from "axios";
import { Result } from "@/models/Result";
import { requestConfig } from "./ApiService";
import ConfigService from "../ConfigService";

export default {
    getLinkedinConnectData(
        clientId?: number,
        checklistClientId?: number,
        message?: string
    ): Promise<Result> {
        return new Promise((resolve, reject) => {
            const url = new URL(ConfigService.linkedinConnectDataUrl);
            const config = {
                ...requestConfig,
                params: {
                    checklistClientId,
                    clientId,
                    message,
                },
            };
            axios
                .post(url.toString(), null, config)
                .then((response) => {
                    const result: Result = response.data;
                    resolve(result);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    loginCustomer(clientId: number): Promise<Result> {
        return new Promise((resolve) => {
            const url = new URL(ConfigService.linkedinLoginCustomerUrl);

            const w = 850;
            const h = 800;
            const dualScreenLeft =
                window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop =
                window.screenTop !== undefined ? window.screenTop : window.screenY;
            const width =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                screen.width;
            const height =
                window.innerHeight ||
                document.documentElement.clientHeight ||
                screen.height;
            const systemZoom = width / window.screen.availWidth;
            const left = (width - w) / 2 / systemZoom + dualScreenLeft;
            const top = (height - h) / 2 / systemZoom + dualScreenTop;

            const win = window.open(
                `${url}?clientID=${clientId}`,
                "windowname1",
                `width=${w / systemZoom}, height=${h / systemZoom}, top=${top}, left=${left}`
            );

            const checkWinClosed = setInterval(() => {
                if (win && win.closed) {
                    clearInterval(checkWinClosed);
                    resolve({ Message: "", Success: true });
                }
            }, 200);
        });
    },

    sendConnectMessage(email: string, clientName: string, msg: string): Promise<Result> {
        return new Promise((resolve, reject) => {
            const url = new URL(ConfigService.linkedinSendConnectMessageUrl);
            const config = {
                ...requestConfig,
                params: {
                    clientName,
                    email,
                    msg,
                },
            };
            axios
                .post(url.toString(), null, config)
                .then((response) => {
                    resolve({
                        Message: response.data.message,
                        Success: response.data.success,
                    });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};
